import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { DateHelper } from '@app/date-helper';
import { LocaleService } from '@app/locale.service';
import { Observable, filter, map, of, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DefaultQueryParamsGuard implements CanActivate {

  private navigated = false;

  constructor(
    private localeService: LocaleService,
    private router: Router
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.navigated = false;
      });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    let paramsUpdated = false;

    let originalCheckInDate = next.queryParamMap.get('checkInDate');
    let checkInAnchor;

    // TODO dont compare dates here, compare days
    if (originalCheckInDate && DateHelper.isValidDate(originalCheckInDate) && new Date(originalCheckInDate) >= new Date()) {
      checkInAnchor = new Date(originalCheckInDate);
    } else {
      checkInAnchor = new Date();
      paramsUpdated = true;
    }
    const checkInDate = DateHelper.formatDate(checkInAnchor);

    let originalCheckOutDate = next.queryParamMap.get('checkOutDate');
    let checkOutAnchor;

    if (originalCheckOutDate && new Date(originalCheckOutDate) > checkInAnchor && DateHelper.isValidDate(originalCheckOutDate)) {
      checkOutAnchor = new Date(originalCheckOutDate);
    } else {
      checkOutAnchor = checkInAnchor;
      checkOutAnchor.setDate(checkOutAnchor.getDate() + 1);
      paramsUpdated = true;
    }
    // const normalizedCheckOutDate = DateHelper.normalizeDateToUTC(checkOutAnchor);
    // normalizedCheckOutDate.setHours(0);
    const checkOutDate = DateHelper.formatDate(checkOutAnchor);

    let originalNoOfGuests = next.queryParamMap.get('noOfGuests');
    let noOfGuests;
    if (isNaN(+originalNoOfGuests)) {
      noOfGuests = 1;
      paramsUpdated = true;
    } else {
      noOfGuests = originalNoOfGuests ?? 1;
    }

    if (!this.navigated) {

      return this.localeService.currentCurrency
        .pipe(
          map(currency => {
            // If params were updated, navigate with the updated query params
            if (paramsUpdated) {
              this.router.navigate([state.url.split('?')[0]], {
                queryParams: {
                  checkInDate,
                  checkOutDate,
                  noOfGuests,
                  currency: currency.code
                },
                queryParamsHandling: 'merge',
              });
              this.navigated = true;
              return false;
            }
            this.navigated = false;
            return true;
          }),
          take(1)
        )
    }

    this.navigated = false; // Reset the flag for future activations
    return true;
  }
}
